module.exports = __webpack_public_path__ + "img/marie.94384a47.jpg";